import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Admin from "./Admin";
import Allpicture from "./component/Allpicture";
import Gallery from "./component/Gallery";
import Home from "./component/Home";
import Login from "./component/Login";
import Uploadfile from "./component/Uploadfile";
import Uploadpic from "./component/Uploadpic";
import Viewcontact from "./component/Viewcontact";
import About from "./component/About";
import Contact from "./component/Contact";
import Profile from "./Profile";
import Schooldocument from "./component/Schooldocument";
import Try from "./component/Try";
import Game from "./component/Game";
import Tiktaktoe from "./component/Tiktaktoe";
import Plusgame from "./component/Plusgame";
import Quiz from "./component/Quiz";
import Analysis from "./component/Analysis";
import Morequiz from "./component/Morequiz";
import ChooseTemplates from "./component/ChooseTemplates";
import CertificateTemp2 from "./component/CertificateTemp2";
import Try2 from "./component/Try2";
import CertificateTemp3 from "./component/CertificateTemp3";
import Try3 from "./component/Try3";
import CertificateTemp4 from "./component/CertificateTemp4";
import Try4 from "./component/Try4";
import Samridhi from "./component/Samridhi";
import Protected from "./component/Protected";
import CertificateTemp5 from "./component/CertificateTemp5";
import Try5 from "./component/Try5";
import Try6 from "./component/Try6";
import CertificateTemp6 from "./component/CertificateTemp6";
import Certitry from "./component/Certitry";

function App() {
  return (
    <div>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/allpicture" element={<Allpicture />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/admin" element={<Admin />}></Route>
          <Route path="/profile" element={<Profile />}></Route>
          <Route path="/viewcontact" element={<Viewcontact />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          {/* <Route path="/uploadpic" element={<Protected Component={<Uploadpic />}/>}></Route> */}
          <Route path="/uploadpic" element={<Uploadpic />}></Route>
          <Route path="/uploadfile" element={<Uploadfile />}></Route>
          <Route path="/certificate" element={<Schooldocument />}></Route>
          <Route path="/try" element={<Try />}></Route>
          <Route path="/game" element={<Game />}></Route>
          <Route path="/tiktaktoe" element={<Tiktaktoe />}></Route>
          <Route path="/plusgame" element={<Plusgame/>}></Route>
          <Route path="/quiz" element={<Quiz/>}></Route>
          <Route path="/analysis" element={<Analysis/>}></Route>
          <Route path="/quiz2" element={<Morequiz/>}></Route>
          <Route path="/choosetemplates" element={<ChooseTemplates/>}></Route>
          <Route path="/certificate2" element={<CertificateTemp2/>}></Route>
          <Route path="/certificate3" element={<CertificateTemp3/>}></Route>
          <Route path="/certificate4" element={<CertificateTemp4/>}></Route>
          <Route path="/try2" element={<Try2/>}></Route>
          <Route path="/try3" element={<Try3/>}></Route>
          <Route path="/try4" element={<Try4/>}></Route>
          <Route path="/try5" element={<Try5/>}></Route>
          <Route path="/try6" element={<Try6/>}></Route>
          <Route path="/samridhi" element={<Samridhi/>}></Route>
          <Route path="/certificate5" element={<CertificateTemp5/>}></Route>
          <Route path="/certificate6" element={<CertificateTemp6/>}></Route>
          <Route path="/certitry" element={<Certitry/>}></Route>
         
          
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
